import React, { useEffect } from 'react';
import { useAppSelector } from '../../hooks/redux';
import { websocketService } from '../../services/websocket';

interface WebSocketProviderProps {
  children: React.ReactNode;
}

const WebSocketProvider: React.FC<WebSocketProviderProps> = ({ children }) => {
  const { isAuthenticated, accessToken } = useAppSelector((state) => state.auth);
  const { connected: wsConnected } = useAppSelector((state) => state.websocket);

  useEffect(() => {
    // Connect WebSocket if authenticated
    if (isAuthenticated && accessToken && !wsConnected) {
      websocketService.connect(accessToken);
    } else if (!isAuthenticated) {
      websocketService.disconnect();
    }

    return () => {
      if (!isAuthenticated) {
        websocketService.disconnect();
      }
    };
  }, [isAuthenticated, accessToken, wsConnected]);

  return <>{children}</>;
};

export default WebSocketProvider;

